import { Injectable } from '@angular/core';
import { FileDownloadOptions } from '../models/config-view-models';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor() {}

  handleFileStreamResponse(options: FileDownloadOptions): void {
    const {
      url,
      fileName,
      download = false,
      openInNewTab = false
    } = options;

    fetch(url)
      .then(async (res) => {
        if (!res.ok) throw new Error(`HTTP error ${res.status}`);

        const contentType = res.headers.get('Content-Type') || 'application/octet-stream';
        const disposition = res.headers.get('Content-Disposition') || '';
        const blob = await res.blob();

        let inferredFileName = fileName;
        const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
        if (!inferredFileName && match) {
          inferredFileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
        }

        if (!inferredFileName) {
          inferredFileName = 'downloaded-file' + this.inferExtensionFromMime(contentType);
        }

        const fileURL = URL.createObjectURL(new Blob([blob], { type: contentType }));

        if (openInNewTab || (contentType === 'application/pdf' && !download)) {
          const newTab = window.open();
          if (newTab) {
            newTab.document.write(
              `<iframe src="${fileURL}" frameborder="0" style="border:0; top:0; left:0; bottom:0; right:0; width:100%; height:100%;" allowfullscreen></iframe>`
            );
          }
        }

        if (download || !openInNewTab || contentType !== 'application/pdf') {
          const a = document.createElement('a');
          a.href = fileURL;
          a.download = inferredFileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch((err) => console.error('File handling failed:', err));
  }

  private inferExtensionFromMime(mimeType: string): string {
    switch (mimeType) {
      case 'application/pdf': return '.pdf';
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return '.xlsx';
      case 'application/vnd.ms-excel': return '.xls';
      case 'text/csv': return '.csv';
      case 'application/zip': return '.zip';
      default: return '';
    }
  }
}
